@if ({
  savedCart: savedCart$ | async,
  }; as content) {
  <!-- ITEMS -->
  <review-items [cartOrder]="content.savedCart || {}" [displayDates]="false" [displayValues]="false"></review-items>
}
